import * as React from "react";
import type { SVGProps } from "react";
const SvgMonitorWebEffectiveness = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M4.988 3.526A3.178 3.178 0 0 0 1.81 6.704v37.695a3.178 3.178 0 0 0 3.178 3.177h33.725V49.3H4.988a4.9 4.9 0 0 1-4.9-4.9V6.704a4.9 4.9 0 0 1 4.9-4.9H50.24a4.9 4.9 0 0 1 4.9 4.9V34.3h-1.722V6.704a3.178 3.178 0 0 0-3.178-3.178H4.988Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M54.279 15.53H0v-1.722h54.279v1.722Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M10.77 9.127a2.692 2.692 0 1 1-5.385 0 2.692 2.692 0 0 1 5.385 0Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M8.078 10.097a.97.97 0 1 0 0-1.94.97.97 0 0 0 0 1.94Zm0 1.722a2.692 2.692 0 1 0 0-5.385 2.692 2.692 0 0 0 0 5.385Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M19.387 9.127a2.692 2.692 0 1 1-5.385 0 2.692 2.692 0 0 1 5.385 0Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M16.694 10.097a.97.97 0 1 0 0-1.94.97.97 0 0 0 0 1.94Zm0 1.722a2.692 2.692 0 1 0 0-5.385 2.692 2.692 0 0 0 0 5.385Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M28.002 9.127a2.692 2.692 0 1 1-5.385 0 2.692 2.692 0 0 1 5.385 0Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M25.31 10.097a.97.97 0 1 0 0-1.94.97.97 0 0 0 0 1.94Zm0 1.722a2.692 2.692 0 1 0 0-5.385 2.692 2.692 0 0 0 0 5.385Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M33.536 20.497c0-.59.478-1.068 1.068-1.068h14.1a1.068 1.068 0 1 1 0 2.136h-14.1c-.59 0-1.068-.478-1.068-1.068ZM33.536 24.343c0-.59.478-1.069 1.068-1.069h14.1a1.068 1.068 0 1 1 0 2.137h-14.1c-.59 0-1.068-.478-1.068-1.068ZM33.536 28.188c0-.59.478-1.068 1.068-1.068h5.3a1.068 1.068 0 1 1 0 2.136h-5.3c-.59 0-1.068-.478-1.068-1.068ZM6.836 36.85c0-.589.479-1.067 1.069-1.067h17.518a1.068 1.068 0 1 1 0 2.136H7.905c-.59 0-1.069-.478-1.069-1.068ZM6.836 40.697c0-.59.479-1.069 1.069-1.069h17.518a1.068 1.068 0 1 1 0 2.137H7.905c-.59 0-1.069-.478-1.069-1.068Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M23.928 20.38H9.4a.841.841 0 0 0-.841.841v7.96c0 .464.376.84.841.84h14.528a.842.842 0 0 0 .841-.84v-7.96a.841.841 0 0 0-.841-.841ZM9.4 18.658a2.564 2.564 0 0 0-2.564 2.563v7.96A2.564 2.564 0 0 0 9.4 31.743h14.528a2.564 2.564 0 0 0 2.564-2.564v-7.959a2.564 2.564 0 0 0-2.564-2.563H9.4Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="m53.228 52.362 4.57 7.259a1.703 1.703 0 0 0 2.456.46l1.28-.951a1.703 1.703 0 0 0 .235-2.525l-5.852-6.308c-1.407-1.516-3.79.315-2.689 2.065Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M55.343 50.83c-.76-.819-2.046.17-1.452 1.114l4.57 7.26a.92.92 0 0 0 1.326.248l1.281-.951a.919.919 0 0 0 .126-1.363l-5.85-6.308Zm-2.778 1.95c-1.609-2.556 1.873-5.23 3.927-3.016l5.851 6.308a2.486 2.486 0 0 1-.34 3.687l-1.282.951a2.486 2.486 0 0 1-3.586-.672l-4.57-7.259Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M44.574 51.014a9.484 9.484 0 1 0 4.91-18.322 9.484 9.484 0 0 0-4.91 18.322Zm-.446 1.664c5.979 1.602 12.124-1.946 13.725-7.925 1.602-5.978-1.945-12.123-7.924-13.725-5.978-1.602-12.123 1.946-13.725 7.925-1.602 5.978 1.946 12.123 7.924 13.725Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMonitorWebEffectiveness;
